import { NgModule, Component } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { InfrastructureFeedbackListComponent } from './infrastructure-feedback-list/infrastructure-feedback-list.component';
import { InfrastructureFeedbackViewComponent } from './infrastructure-feedback-view/infrastructure-feedback-view.component';

const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: 'list-page',
        component: InfrastructureFeedbackListComponent,
        data: {
          title: "List Page",
          breadcrumb: "List Page"
        }
      },
      /* {
        path: 'view-page',
        component: InfrastructureFeedbackViewComponent,
        data: {
          title: "View Page",
          breadcrumb: "View Page"
        }
      }, */
      {
        path: 'infrastructure-feedback-view/:id',
        component: InfrastructureFeedbackViewComponent,
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class InfrastructureFeedbackRoutingModule { }
